export default __webpack_public_path__ + "static/media/Pneum2.b33f09a8.png";